import styled from "styled-components";

export const TextStyled = styled.main`
  p {
    font-size: 19px;
    color: #fff;
    line-height: 1.5;
  }

  .title-h2 {
    font-size: 60px;
  }
  
  .categories__inner {
    max-width: 1200px;
    margin: 0 auto;
  }
`
